import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-24c121cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "connect_container"
};
const _hoisted_2 = {
  class: "title"
};
import bus from '@/utils/mitt.js';
export default /*#__PURE__*/_defineComponent({
  __name: 'connectTimeout',
  props: ['errorType'],
  emits: ['changeStatus'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const errorInfo = {
      overload: {
        tip: '使用人数过多，对话连接失败',
        btnName: '重新连接'
      },
      close: {
        tip: '长时间未使用，当前对话已关闭',
        btnName: '开始新的对话'
      },
      exit: {
        tip: '长时间未使用，当前对话已关闭',
        btnName: '开始新的对话'
      }
    };
    const refresh = () => {
      location.reload();
    };
    const reConnect = () => {
      bus.emit('reConnect');
      emits('changeStatus', false);
    };
    return (_ctx, _cache) => {
      var _errorInfo$__props$er, _errorInfo$__props$er2, _errorInfo$__props$er3;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString((_errorInfo$__props$er = errorInfo[__props.errorType]) === null || _errorInfo$__props$er === void 0 ? void 0 : _errorInfo$__props$er.tip), 1), __props.errorType == 'overload' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: refresh,
        class: "btn-def btn-large"
      }, _toDisplayString((_errorInfo$__props$er2 = errorInfo[__props.errorType]) === null || _errorInfo$__props$er2 === void 0 ? void 0 : _errorInfo$__props$er2.btnName), 1)) : _createCommentVNode("", true), ['close', 'exit'].includes(__props.errorType) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: reConnect,
        class: "btn-def btn-large"
      }, _toDisplayString((_errorInfo$__props$er3 = errorInfo[__props.errorType]) === null || _errorInfo$__props$er3 === void 0 ? void 0 : _errorInfo$__props$er3.btnName), 1)) : _createCommentVNode("", true)]);
    };
  }
});